export const MODEL_PROVIDERS_TABLE_LAYOUT = {
  entityTableId: "ai-model-providers",
  defaultPageSize: 20,
  defaultSort: { attributeId: "provider", direction: "asc" },
  // `last_request_at` stays hidden until the backend records requests.
  defaultDisplayedAttributes: ["provider", "default_model_id", "used_by_features"],
  defaultColumnOrder: ["provider", "default_model_id", "used_by_features", "last_request_at"]
};
export const DISABLED_MODEL_PROVIDER_EXPLANATION = "This provider is disabled in the server configuration, so AI features do not use it. You can only delete it to remove its stored credentials.";
